exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1-Pil7D8GazAjhWz54g4td{position:relative;display:block;width:100%;max-height:700px}._1-Pil7D8GazAjhWz54g4td iframe{position:absolute;width:100%;height:100%;top:0;left:0;right:0;bottom:0}\n", ""]);

// Exports
exports.locals = {
	"EmbedViewer": "_1-Pil7D8GazAjhWz54g4td"
};